import { createContext } from 'react';

import { PageContext as PageContextProps } from './interfaces';

export const PageContext = createContext<PageContextProps>({} as PageContextProps);
